// extracted by mini-css-extract-plugin
export default {"row":"FileRow_row__TBJZG","info":"FileRow_info__P60su"};